export enum StatusEnum {
  active = 'global.active',
  inactive = 'global.inactive',
}

export enum BooleanStatusEnum {
  true = 'global.active',
  false = 'global.inactive',
}
